import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="ba-title" data-id="element-48" data-mp="26k9wuh2e19bf">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="22mc8thkcst9m">
        <SectionHeading title={<span id="ba-title" data-id="element-51" data-mp="2zba36yo6yp69">Before vs. <em className="text-brand" data-id="element-52" data-mp="2zai6tlmrsnex">with</em> the Sensory Clinical Route™</span>} data-id="element-50" data-mp="2zb1s9cbmptxp" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-53" data-mp="2ud080o2gvokn">
          <div className="rounded-3xl border-2 border-alert/25 bg-white p-6 sm:p-8" data-id="element-54" data-mp="2qabva5amtxie">
            <div className="flex items-center gap-3" data-id="element-55" data-mp="2qc6khvsxsbsa">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert text-white" data-id="element-56" data-mp="2lah5k52lfdyx">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-57" data-mp="1ewrmqpswlfw4" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase tracking-wide text-alert" data-id="element-58" data-mp="19v27exyneg28">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-59" data-mp="175vsynl4vfhs">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-ink/80" data-id="element-60" data-mp="1c35uh1lsrhlz">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-61" data-mp="y3wbju67i9eb" />
                  <span data-id="element-62" data-mp="132psxxom6kjr">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta bg-[#F0FBF4] p-6 shadow-[0_16px_40px_-16px_rgba(22,163,74,0.45)] sm:p-8" data-id="element-63" data-mp="oe314whsw0bn">
            <div className="flex items-center gap-3" data-id="element-64" data-mp="t7o472y93khp">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-65" data-mp="ff7uxkeraq8c">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="jgtc3hybpqoc" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase tracking-wide text-cta-dark" data-id="element-67" data-mp="5fqtxgag90ip">After</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-68" data-mp="adsc7z01wvt4">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-relaxed text-ink" data-id="element-69" data-mp="2c5at9drcwsbp">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-70" data-mp="27cr89vqcauwv" />
                  <span data-id="element-71" data-mp="23d0hvt4q6gsv">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-72" data-mp="1yefks2krsd8n">
          <CTAButton label="I want the “After” in my practice" data-id="element-73" data-mp="2v3513ogr0xsi" />
        </div>
      </div>
    </section>;
}